import { Injectable } from "@angular/core";
import { CheckRegisterRequest, CheckRegisterResponse, ConfirmRegisterUserPayload, ConfirmRegisterUserResponse, MyAddressAllResponse, RegisterUserPayload, RegisterUserResponse, UpdateNamePayload } from "../../../models/user.model";
import { HttpClient, HttpHeaders, HttpParams } from "@angular/common/http";
import { ConfigService } from "../../config.service";
import { ApiMethodService } from "../../../../tools/services/api/method-api/apiMethod.service";
import { Observable } from "rxjs";
import { environment } from '../../../../../environments/environment';
import { RegisterMemberNewPayload } from "../../../models/member.model";
import { StatusAPIResponse, TaxpayerInfo } from "../../../models/information.model";
import { ObjectFeeResponse } from "../../../models/parking.model";
import { CreateTransactionResponse, ParkingTransactionEVDto } from "../../../models/ev.model";
import { ParkingLocation, ParkingLocationDetail, ParkingSiteDropdownResponse } from "../../../models/parking-center/parking-center.model";

@Injectable({
    providedIn: 'root',
})

export class ApiParkingCenterService {
    private tokenUrl = `${environment.apiPrivateUrl}`;

    constructor(
        private http: HttpClient,
        private configService: ConfigService,
        private apiMethods: ApiMethodService,
    ) { }

    ParkingLocation(token: string): Observable<ParkingLocation[]> {
        const headers = new HttpHeaders({
            'Content-Type': 'application/json',
        });

        console.log(
            'Header : ',
            headers,
            '\nURL : ',
            this.tokenUrl + '/Cityparking/ParkingLocation',
            '\nToken : ',
            token,
        );
        return this.http.get<ParkingLocation[]>(
            this.tokenUrl + '/Cityparking/ParkingLocation',
            { headers },
        );
    }


    ParkingLocationDetail(
        token: string,
        siteID: number,
    ): Observable<ParkingLocationDetail> {
        const headers = new HttpHeaders({
            'Content-Type': 'application/json',
        });
        const params = new HttpParams().set('siteID', siteID);
        // console.log(
        //   'Header : ',
        //   headers,
        //   '\nURL : ',
        //   this.tokenUrl + '/Cityparking/ParkingLocationDetails',
        //   '\nBody : ',
        //   params
        // );
        return this.http.get<ParkingLocationDetail>(
            this.tokenUrl + '/Cityparking/ParkingLocationDetails',
            {
                headers,
                params,
            },
        );
    }

    searchOnlineParkingSites(search: string): Observable<ParkingSiteDropdownResponse[]> {
        return this.http.get<ParkingSiteDropdownResponse[]>(
            `${this.tokenUrl}/Cityparking/searchOnlineParkingSites?search=${encodeURIComponent(search)}`
        );
    }
}